module.exports = __webpack_public_path__ + "media/icons/inactive-sml-c9abb7f0.svg";